import {
  NodeResult,
  NodeResults,
  NodeResultsHistoric,
  NodeResultsHistoricValue,
  RunResults,
  RunResultsHistoric,
} from "@custom-types/modelRun"
import {
  getNodeUnitByLabel,
  graphViewGroupNodeLabelToSampleNode,
} from "@features/graph/utils/graphUtils"

function isStringOrNumberArray<T extends string | number>(value: unknown): value is T[] {
  if (!value) return false
  if (!Array.isArray(value)) return false
  if (value.length === 0) return true

  return (
    value.every((item) => typeof item === "string") ||
    value.every((item) => typeof item === "number")
  )
}

export const convertHistoricToRunResults = <T extends string | number = number>(
  data?: RunResultsHistoric,
): RunResults<T> | undefined => {
  if (!data) return undefined
  const out: RunResults<T> = {}
  Object.keys(data).forEach((key) => {
    const runData: NodeResults<T> = {}
    const nodes = data[key]
    if (!nodes) return

    Object.entries(nodes).forEach(([nodeKey, node]) => {
      if (!("timesteps" in node) || !node.timesteps) return

      const result: NodeResult<T>[] = []
      Object.keys(node.timesteps).forEach((timestep) => {
        const timestepData = node.timesteps?.[timestep]
        if (!isStringOrNumberArray<T>(timestepData)) return

        result.push({
          key,
          node_key: nodeKey,
          timestep: parseInt(timestep),
          data: timestepData,
          unit_format: node.unitFormat || getNodeUnitByLabel(nodeKey),
        })
      })
      runData[nodeKey] = result
    })
    out[key] = runData
  })

  return out
}

export const getNodeResults = (
  historicResponse: RunResultsHistoric | undefined,
  runId: string,
  nodeLabel: string,
): NodeResultsHistoricValue | undefined => {
  if (!historicResponse) return

  const nodesResults = historicResponse[runId]
  if (!nodesResults) return

  if (Object.keys(nodesResults).length === 0) return

  const safeNodesResults = nodesResults as NodeResultsHistoric // safely assert it won't be empty object case

  return safeNodesResults[graphViewGroupNodeLabelToSampleNode(nodeLabel)]
}
